import React, { useEffect, useState } from "react";
import "./OverlaySlideImages.scss";
import { ExpandButton } from "../../../../../components/ExpandButton/ExpandButton";
import { useOverlaySubject } from "../../../../../hooks/useOverlaySubject";

interface IProps {
    images: string[]
}

const animationDuration = 500;

export function OverlaySlideImages({ images }: IProps) {
    const [animating, setAnimating] = useState(false);
    const { subject } = useOverlaySubject();
    const [activeIndex, setActiveIndex] = useState<number>(0);

    useEffect(() => {
        setActiveIndex(0);
    }, [subject])

    useEffect(() => {
        setAnimating(true);
        const timeout = setTimeout(() => {
            setAnimating(false);
        }, animationDuration);
        return () => {
            setAnimating(false);
            clearTimeout(timeout);
        }
    }, [activeIndex])

    if (images.length === 0) {
        return <></>
    }

    return (
        <div className={`overlay-slide-images-wrapper ${animating ? 'animated' : ''}`} data-active={activeIndex}>
            <div className="overlay-slide-images-inner">
                <div className="overlay-slide-images-container">
                    {images.map((image, index) => {
                        return <div key={index} className={"overlay-slide-image"}>
                            <img src={image} alt={`slide-${index}`} />
                        </div>;
                    })}
                </div>
            </div>
            <div className={`slide-toggle-wrapper previous ${activeIndex > 0 ? 'visible' : ''}`}>
                <ExpandButton state={'left'} onClick={() => setActiveIndex(activeIndex - 1)} />
            </div>
            <div className={`slide-toggle-wrapper next ${activeIndex < (images.length - 1) ? 'visible' : ''}`}>
                <ExpandButton state={'right'} onClick={() => setActiveIndex(activeIndex + 1)} />
            </div>
        </div>
    )
}
